import sx from "../../styles/Inputs.module.css";

interface RadioProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  calculatorMode: string;
}

const Radio: React.FC<RadioProps> = ({
  label,
  value,
  onChange,
  calculatorMode,
}) => {
  
  return (
    <div className={sx.elRadio}>
      <input
        type="radio"
        name={value}
        id={label}
        value={value}
        checked={calculatorMode === value ? true : false}
        onChange={() => onChange(value)}
      />
      <label className={sx.elRadioStyle} htmlFor={value}></label>

      {label && <span style={{ margin: '0 0.5rem' }}>{label}</span>}
    </div>
  );
};

export default Radio;
